import type { ReactNode } from 'react';

import { cn } from '@shared/utils/cn';

type Props = {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
};

export const EmptyContent = ({ title, description, icon, className }: Props) => (
  <div className={cn('flex flex-col items-center justify-center gap-2 px-6 py-12 text-center', className)}>
    {icon && <div className="mb-2 flex text-5xl text-muted-foreground/60 [&>svg]:size-12">{icon}</div>}
    <h3 className="text-lg font-semibold text-muted-foreground">{title}</h3>
    {description && <p className="text-sm text-muted-foreground/70">{description}</p>}
  </div>
);
